import createIcon from '../../createIcon';

/**
 * @component @name NoBackpack
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuODk5NiAyMC44ODUzTDMuNTE5NjEgMi41MDUzMUwyLjA5OTYxIDMuOTE1MzFMNC44NTk2MSA2LjY3NTMxQzQuNzY5NjEgNy4wMDUzMSA0LjcwOTYxIDcuMzM1MzEgNC43MDk2MSA3LjY5NTMxVjE5LjY5NTNDNC43MDk2MSAyMC43OTUzIDUuNjA5NjEgMjEuNjk1MyA2LjcwOTYxIDIxLjY5NTNIMTguNzA5NkMxOS4wNDk2IDIxLjY5NTMgMTkuMzU5NiAyMS42MDUzIDE5LjYzOTYgMjEuNDU1M0wyMC40ODk2IDIyLjMwNTNMMjEuODk5NiAyMC44ODUzWk02LjcwOTYxIDEzLjY5NTNWMTEuNjk1M0g5Ljg3OTYxTDExLjg3OTYgMTMuNjk1M0g2LjcwOTYxWk0xNS41Mzk2IDExLjY5NTNMNy42ODk2MSAzLjg0NTMxQzcuNjk5NjEgMy44NDUzMSA3LjY5OTYxIDMuODM1MzEgNy43MDk2MSAzLjgzNTMxVjEuNjk1MzFIMTAuNzA5NlYzLjY5NTMxSDE0LjcwOTZWMS42OTUzMUgxNy43MDk2VjMuODM1MzFDMTkuNDI5NiA0LjI4NTMxIDIwLjcwOTYgNS44MzUzMSAyMC43MDk2IDcuNjk1MzFWMTYuODY1M0wxOC43MDk2IDE0Ljg2NTNWMTEuNjk1M0gxNS41Mzk2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoBackpack = createIcon('NoBackpack', [
  [
    'path',
    {
      d: 'M21.8996 20.8853L3.51961 2.50531L2.09961 3.91531L4.85961 6.67531C4.76961 7.00531 4.70961 7.33531 4.70961 7.69531V19.6953C4.70961 20.7953 5.60961 21.6953 6.70961 21.6953H18.7096C19.0496 21.6953 19.3596 21.6053 19.6396 21.4553L20.4896 22.3053L21.8996 20.8853ZM6.70961 13.6953V11.6953H9.87961L11.8796 13.6953H6.70961ZM15.5396 11.6953L7.68961 3.84531C7.69961 3.84531 7.69961 3.83531 7.70961 3.83531V1.69531H10.7096V3.69531H14.7096V1.69531H17.7096V3.83531C19.4296 4.28531 20.7096 5.83531 20.7096 7.69531V16.8653L18.7096 14.8653V11.6953H15.5396Z',
      key: 'k61j76',
    },
  ],
]);

export default NoBackpack;
